import React from 'react'
import PropTypes from 'prop-types'
// import './style.css'

// import Button from 'material-ui/RaisedButton'
import { Paper } from 'material-ui'

class Wrapper extends React.Component {

   render() {

      const { noPaper, fullWidth, noPadding, alignLeft, height, width, className } = this.props

      const style = {
         padding: fullWidth ? 0 : 15,
         textAlign: alignLeft ? 'left' : 'center',
         height: height ? height : null,
         width: width ? width : null,
         inner: {
            padding: noPadding ? 0 : 15,
            fontFamily: 'Open Sans, sans-serif',
            fontSize: 16,
         },
      }

      const wrapperClassName = className ? className : null

      // Merge styles with inner style
      Object.assign(style.inner, this.props.style)

      let wrapper
      if (noPaper === true) {
         wrapper = <div className={wrapperClassName} style={style.inner}>{this.props.children}</div>
      } else {
         wrapper = <Paper className={wrapperClassName} style={style.inner}>{this.props.children}</Paper>
      }


      return (
         <div style={style}>
            {wrapper}
         </div>
      )
   }
}
Wrapper.propTypes = {
   children: PropTypes.any,
   noPaper: PropTypes.bool,
   fullWidth: PropTypes.bool,
   noPadding: PropTypes.bool,
   alignLeft: PropTypes.bool,
   style: PropTypes.object,
   height: PropTypes.string,
   className: PropTypes.string,
}
export default Wrapper



// WEBPACK FOOTER //
// ./src/components/Wrapper/index.js